module.exports = __webpack_public_path__ + "img/logo.8446f92d.svg";